import { HIDDENFAULTS_TOKEN, HIDDENFAULTS_REFRESH } from "./constants";


class fetchr {
    options = {};
    constructor(url, json) {
        const contentType = json ? { "Content-Type": "application/json; charset=UTF-8" } : {};
        this.options = {
            json,
            url: `${url}`,
            headers: {
                ...contentType,
            },
        };
    }

    post = (payload) => this.execute("POST", payload);
    postForm = (payload) => this.executeForm("POST", payload);
    delete = (payload) => this.execute("DELETE", payload);
    put = (payload) => this.execute("PUT", payload);
    get = () => this.execute("GET");

    renewToken = () => {
        const t = sessionStorage.getItem(HIDDENFAULTS_TOKEN);
        const r = sessionStorage.getItem(HIDDENFAULTS_REFRESH);
        if (!r || !t) return Promise.reject("Unauthorized");

        return fetch("/renew", {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Authorization: `bearer ${t}`,
            },
            body: JSON.stringify({
                token: t,
                refreshToken: r,
            }),
        }).then(async (response) => {
            if (!response.ok) return Promise.reject("Unauthorized");
            const { token, refreshToken } = await response.json();
            if (token && refreshToken) {
                sessionStorage.setItem(HIDDENFAULTS_TOKEN, token);
                sessionStorage.setItem(HIDDENFAULTS_REFRESH, refreshToken);
            } else {
                return Promise.reject("Unauthorized");
            }
        });
    };

    execute = async (method, payload, isRenewing = false) => {
        const body = payload ? { body: this.options.json ? JSON.stringify(payload) : payload } : {};
        const opts = { ...this.options, method, ...body };
        opts.headers = {
            ...opts.headers,
            Authorization: `bearer ${sessionStorage.getItem(HIDDENFAULTS_TOKEN)}`,
        };

        return fetch(opts.url, opts).then(async (response) => {
            if (response.ok) return response;
            if (response.status == 401 && isRenewing) return Promise.reject("Unauthorized");
            if (response.status == 401) {
                try {
                    await this.renewToken();
                    const r = await this.execute(method, payload, true);
                    return Promise.resolve(r);
                } catch (error) {
                    localStorage.setItem('timeOut', true);
                    window.location.reload();
                }
                return Promise.reject("Unauthorized");
            }

            const json = await response.json();
            return Promise.reject(json);
        });
    };


    executeForm = async (method, payload, isRenewing = false) => {
        
        return fetch(this.options.url, {
            headers: {
                'Accept': 'application/json',
                'Authorization': `bearer ${sessionStorage.getItem(HIDDENFAULTS_TOKEN)}`
            },
            method: 'POST',
            body: payload
        }).then(async (response) => {
            if (response.ok) return response;
            if (response.status == 401 && isRenewing) return Promise.reject("Unauthorized");
            if (response.status == 401) {
                try {
                    await this.renewToken();
                    const r = await this.executeForm(method, payload, true);
                    return Promise.resolve(r);
                } catch (error) {
                    sessionStorage.removeItem(HIDDENFAULTS_TOKEN);
                    sessionStorage.removeItem(HIDDENFAULTS_REFRESH);
                    localStorage.setItem('timeOut', true);
                    window.location.reload();
                }
                return Promise.reject("Unauthorized");
            }

            const json = await response.json();
            return Promise.reject(json);
        });
    };

}

export default (url, json = true) => new fetchr(url, json);
